// Body of the Oscar account-login view: the legacy account-page layout -- the
// brand heading, the LoginStandalone form island, the decorative account
// image, and the customer-service info block. The headings + block copy
// arrive pre-localized as props (server-side gettext, matching the legacy
// {% trans %} path under whatever LANGUAGES the site configures).
import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { Template as LoginStandalone } from "../../templates/LoginStandaloneTemplate";
import { AccountSplitShell } from "../AccountSplitShell";
import { CustomerServiceInfoBlock } from "../CustomerServiceInfoBlock";

type IProps = Immutable<templates.LoginDocumentTemplate>;

export const LoginPageBody = (props: IProps): React.JSX.Element => {
    return (
        <>
            <AccountSplitShell
                heading={props.page_copy?.page_heading}
                sectionHeading={props.page_copy?.section_heading}
            >
                <LoginStandalone {...props.login_standalone} />
            </AccountSplitShell>

            {props.cs_info && <CustomerServiceInfoBlock info={props.cs_info} />}
        </>
    );
};
